/* ------------------------------------------  Template List Types ------------------------------------------ */
export const CycleTemplateListType = {
	PrivateTemplate: 'PrivateTemplate', // תבניות פרטיות שלי או תבניות שאני מנהל
	PublicTemplate: 'PublicTemplate', // תבניות ציבוריות הזמינות לכל המשתמשים
} as const;
export type CycleTemplateListType = (typeof CycleTemplateListType)[keyof typeof CycleTemplateListType];

/* ------------------------------------------  Form List Types ------------------------------------------ */
export const CycleFormListType = {
	PrivateForm: 'PrivateForm', // טפסים פרטיים שלי או טפסים שאני מנהל
	PublicForm: 'PublicForm', // טפסים ציבוריים הזמינים לכל המשתמשים
	SentForm: 'SentForm', // טפסים ששלחתי למילוי על ידי אחרים
} as const;
export type CycleFormListType = (typeof CycleFormListType)[keyof typeof CycleFormListType];

/* ------------------------------------------- Signed Cycle Types ------------------------------------------- */
export const SignedCycleListType = {
	Signed: 'Signed', // מסמכים שכבר חתמתי עליהם ונמצאים בתהליך
	SignedApproved: 'SignedApproved', // מסמכים שחתמתי עליהם עם אישור
	SignedAlert: 'SignedAlert', // מסמכים שחתמתי עליהם עם התראה
	SignedRejected: 'SignedRejected', // מסמכים שחתמתי עליהם וסימנתי כדחויים
	SignedTimeout: 'SignedTimeout', // מסמכים שהזמן לחתימתי עליהם פג
} as const;
export type SignedCycleListType = (typeof SignedCycleListType)[keyof typeof SignedCycleListType];

export const MainCycleListType = {
	All: 'All',
} as const;
export type MainCycleListType = (typeof MainCycleListType)[keyof typeof MainCycleListType];

/* ------------------------------------------  Cycle List Types ------------------------------------------ */
export const CycleListType = {
	InProgress: 'InProgress', // מסמכים שיצרתי והם בתהליך החתמה
	Waiting: 'Waiting', // מסמכים שממתינים לחתימה שלי כעת
	Future: 'Future', // מסמכים שאצטרך לחתום עליהם בעתיד

	Finished: 'Finished', // מסמכים שהושלמו בהצלחה
	Completing: 'Completing', // מסמכים שהושלמה החתימה עליהם ונמצאים בתהליך סיום

	...SignedCycleListType,

	Rejected: 'Rejected', // מסמכים שנדחו על ידי אחד המשתמשים בתהליך
	Canceled: 'Canceled', // מסמכים שבוטלו או שפג תוקפם
	Archive: 'Archive', // מסמכים שהועברו לארכיון

	...CycleTemplateListType,
	Draft: 'Draft', // טיוטות שיצרתי וטרם שלחתי לחתימה

	...CycleFormListType,
	...MainCycleListType,
} as const;

export type CycleListType = (typeof CycleListType)[keyof typeof CycleListType];
